export const MOCKED_TOPIC_NUMBER = 5;
export const MOCKED_ARTICLE_NUMBER = 6;
